import type { ReactNode } from "react";

interface SurfaceProps {
	children: ReactNode;
	className?: string;
	/** Removes the inner padding — use when the child is a table. */
	flush?: boolean;
}

/**
 * A hairline-bordered panel. The app's single elevation primitive: borders do
 * the work that drop shadows would in a heavier design.
 */
export function Surface({ children, className = "", flush = false }: SurfaceProps) {
	return (
		<div
			className={`rounded-xl border border-[var(--c-border)] bg-[var(--c-surface)] ${
				flush ? "" : "p-5"
			} ${className}`}
		>
			{children}
		</div>
	);
}
